import styled from "styled-components";
import { TitleText } from '../../ProductCategoryPage/TitleBannerSection/styled.js';

export const AppSectionContainer = styled.div`
width: 100%;
height: 80vh;
display: block;
margin-top: 30px;
/* border: 1px solid black; */
position: relative;

@media only screen and (max-width: 560px) {
  display: inline-block;
  margin-bottom: 3%;
  height: 100vh;
}
`;

export const Title = styled(TitleText)`
text-align: center;
font-size: 28px;

@media only screen and (max-width: 768px) {
  font-size: 24px;
}

@media only screen and (max-width: 768px) {
  font-size: 22px;
  margin-bottom: 20px;
}
`;

export const ImageWrap = styled.div`
position: absolute;
width: 56%;
height: 60%;
right: 0;
margin-top: 4%;
overflow: hidden;

@media only screen and (max-width: 560px) {
  display: block;
  position: relative;
  margin: auto;
  width: 100%;
  /* bottom: 0; */
  height: 50%;
  margin-top: 4%;
  margin-bottom: 3%;
}
`;

export const AppDetailSection = styled.section`
position: absolute;
left: 120px;
height: 60%;
margin-top: 5%;
width: 30%;
color: black;
white-space: nowrap;

@media only screen and (max-width: 769px) {
  left: 40px;
}

@media only screen and (max-width: 560px) {
  display: block;
  position: relative;
  margin: auto;
  margin-bottom: auto;
  text-align: center;
  height: 40%;
  white-space: normal;
  width: 80%;
  left: 0px;
}

 .apply {
   font-size: 20px;
   font-family: "Montserrat";
   letter-spacing: 0px;
   font-weight: 900;
   text-align: left;
   letter-spacing: .4px;
  
   @media only screen and (max-width: 560px) {
     text-align: center;
     font-size: 17px;
   }

   &.in-person {
    margin-top: 10px;
    margin-bottom: 10px;;
   }

   &.online {
    margin-top: 50px;
   }

 }
.address {
  font-family: "Helvetica";
  margin-bottom: 5px;
  font-size: 15px;
  font-weight: 500;
  letter-spacing: .6px;
  color: black;

  &.click>a, &.click {
    text-decoration: underline;
    color: black;
    &:hover{
      color: black;
      cursor: pointer;
    }
  }
   }
`;